import { useMutation, UseMutationResult } from 'react-query'

import { useMyReadingAction } from './useMyReadingAction'

export function useUpdateBookShelf(
  onSuccess?: (
    data: any,
    variables: {
      bookId: number
      action: string
    },
    context: unknown
  ) => void | Promise<unknown>,
  onError?: (
    error: unknown,
    variables: any,
    context: unknown
  ) => void | Promise<unknown>
): UseMutationResult<
  any,
  unknown,
  {
    bookId: number
    action: string
  },
  unknown
> {
  const myReadingClient = useMyReadingAction()
  return useMutation(book => myReadingClient.updateMyShelf(book), {
    onSuccess,
    onError,
  })
}
